import { notFoundRouteCase, Route, route, Updater } from 'widgets-for-react'
import { search } from '../custom_pages/search_overview'
import { initialDrupalPageState } from '../drupalPage/state'
import { initialOverviewState } from '../overview/state'
import { PageKind, pageKinds, pageKindToSlug, translatedCareersSlug } from '../overview/utils'
import { initialPressReleaseState } from '../pressRelease/state'
import { PublicSiteState } from '../state'
import { initialStoryOverviewState } from '../storyOverview/state'
import { getLangFromUrl } from '../utils/history.mod'
import { initialVacancyDetailState } from '../vacancies/vacancyDetail/state'
import { OverviewPageParams } from './state'

export const vacancyDetailPathPattern = `(/:lang)/${
  translatedCareersSlug[getLangFromUrl()]
}/vacancies/id/:vacancyId/:title/:tag(/:success)`

export const routesArray: Array<Route<Updater<PublicSiteState>>> = [
  route<{}, Updater<PublicSiteState>>(
    '/portal' + '/*',
    () =>
      (state): PublicSiteState => ({ ...state, route: { kind: 'ignore' } })
  ),
  route<{}, Updater<PublicSiteState>>(
    '/portal' + '/',
    () =>
      (state): PublicSiteState => ({ ...state, route: { kind: 'ignore' } })
  ),
  route<{}, Updater<PublicSiteState>>('(/:lang)/pipedrive-form', () => (state) => ({
    ...state,
    route: { kind: 'pipedriveForm' }
  })),
  route<{}, Updater<PublicSiteState>>('/select-locale', () => (state) => ({
    ...state,
    route: { kind: 'selectLocale' }
  })),
  route<{}, Updater<PublicSiteState>>(
    `(/:lang)/request-documents`,
    () =>
      (state): PublicSiteState => ({ ...state, route: { kind: 'requestDocuments' } })
  ),
  route<{ pageOrSlug: string; lang: string }, Updater<PublicSiteState>>(
    `(/:lang)/stories(/:pageOrSlug)`,
    ({ lang, pageOrSlug }) =>
      (state): PublicSiteState => {
        const parsedPage = pageOrSlug == undefined ? 0 : parseInt(pageOrSlug)
        return isNaN(parsedPage)
          ? {
              ...state,
              route: {
                kind: 'drupalPage',
                slug: `${lang == undefined ? '' : `${lang}/`}stories/${pageOrSlug}`,
                ...initialDrupalPageState(`${lang == undefined ? '' : `${lang}/`}stories/${pageOrSlug}`)
              }
            }
          : { ...state, route: { kind: 'storyOverview', lang, ...initialStoryOverviewState(lang, parsedPage) } }
      }
  ),
  route<{ page: string; lang: string; query: string }, Updater<PublicSiteState>>(
    `(/:lang)/search/:query(/:page)`,
    ({ page, lang, query }) =>
      (state): PublicSiteState => {
        const parsedPage = page == undefined ? 0 : parseInt(page)
        return isNaN(parsedPage)
          ? { ...state, route: { kind: '404' } }
          : {
              ...state,
              search_overview: {
                overview_page: parsedPage,
                current_query: query,
                get_searches: search(query, '', parsedPage, 10, lang)
              },
              route: { kind: 'search_overview', slug: 'search', query: query, page: page && parseInt(page), lang: lang }
            }
      }
  ),
  route<{}, Updater<PublicSiteState>>(
    '/en/styleguide',
    () =>
      (state): PublicSiteState => ({ ...state, route: { kind: 'styleguide' } })
  ),
  route<{ id: string }, Updater<PublicSiteState>>(
    '/en/press-releases/:id',
    ({ id }) =>
      (state): PublicSiteState => ({
        ...state,
        press: initialPressReleaseState(id),
        route: { kind: 'press', page: id }
      })
  ),
  route<OverviewParams, Updater<PublicSiteState>>(
    `/:lang/${translatedCareersSlug[getLangFromUrl()]}/:slug(/:page)`,
    ({ lang, slug, page, ...params }) =>
      (state): PublicSiteState => {
        const parsedPage = page == undefined ? 0 : parseInt(page)

        if (isNaN(parsedPage) || !pageKinds.map((pageKind) => pageKindToSlug(pageKind)).includes(slug)) {
          const completeSlug = `${lang}/${translatedCareersSlug[getLangFromUrl()]}/${
            page == undefined ? slug : `${slug}/${page}`
          }`
          return {
            ...state,
            route: { kind: 'drupalPage', slug: completeSlug, ...initialDrupalPageState(completeSlug) }
          }
        }

        if (params.industryTag == undefined) params.industryTag = []
        if (params.typeTag == undefined) params.typeTag = []
        if (params.vacancyContractTypeTag == undefined) params.vacancyContractTypeTag = []
        if (params.vacancyCountryTag == undefined) params.vacancyCountryTag = []
        if (params.vacancyStateProvinceTag == undefined) params.vacancyStateProvinceTag = []
        if (params.vacancyLocationTag == undefined) params.vacancyLocationTag = []
        if (params.vacancyDepartmentTag == undefined) params.vacancyDepartmentTag = []
        if (params.newsTypeTag == undefined) params.newsTypeTag = []
        if (params.teamMemberDisciplineTag == undefined) params.teamMemberDisciplineTag = []
        if (params.testimonialTag == undefined) params.testimonialTag = []
        params = Object.entries(params).reduce((xs, x) => {
          if (x[0].includes('industryTag') && x[0] != 'industryTag')
            typeof x[1] == 'string' ? xs.industryTag.push(x[1]) : xs.industryTag.push(...x[1])
          if (x[0].includes('typeTag') && x[0] != 'typeTag')
            typeof x[1] == 'string' ? xs.typeTag.push(x[1]) : xs.typeTag.push(...x[1])
          if (x[0].includes('vacancyContractTypeTag') && x[0] != 'vacancyContractTypeTag')
            typeof x[1] == 'string' ? xs.vacancyContractTypeTag.push(x[1]) : xs.vacancyContractTypeTag.push(...x[1])
          if (x[0].includes('vacancyCountryTag') && x[0] != 'vacancyCountryTag')
            typeof x[1] == 'string' ? xs.vacancyCountryTag.push(x[1]) : xs.vacancyCountryTag.push(...x[1])
          if (x[0].includes('vacancyStateProvinceTag') && x[0] != 'vacancyStateProvinceTag')
            typeof x[1] == 'string' ? xs.vacancyStateProvinceTag.push(x[1]) : xs.vacancyStateProvinceTag.push(...x[1])
          if (x[0].includes('vacancyLocationTag') && x[0] != 'vacancyLocationTag')
            typeof x[1] == 'string' ? xs.vacancyLocationTag.push(x[1]) : xs.vacancyLocationTag.push(...x[1])
          if (x[0].includes('vacancyDepartmentTag') && x[0] != 'vacancyDepartmentTag')
            typeof x[1] == 'string' ? xs.vacancyDepartmentTag.push(x[1]) : xs.vacancyDepartmentTag.push(...x[1])
          if (x[0].includes('newsTypeTag') && x[0] != 'newsTypeTag')
            typeof x[1] == 'string' ? xs.newsTypeTag.push(x[1]) : xs.newsTypeTag.push(...x[1])
          if (x[0].includes('teamMemberDisciplineTag') && x[0] != 'teamMemberDisciplineTag')
            typeof x[1] == 'string' ? xs.teamMemberDisciplineTag.push(x[1]) : xs.teamMemberDisciplineTag.push(...x[1])
          if (x[0].includes('testimonialTag') && x[0] != 'testimonialTag')
            typeof x[1] == 'string' ? xs.testimonialTag.push(x[1]) : xs.testimonialTag.push(...x[1])
          return xs
        }, params)

        const overviewPageParams: OverviewPageParams = {
          slug,
          page: parsedPage,
          searchQuery: params.searchQuery,
          industryTag: typeof params.industryTag == 'string' ? [params.industryTag] : params.industryTag,
          typeTag: typeof params.typeTag == 'string' ? [params.typeTag] : params.typeTag,
          vacancyContractTypeTag:
            typeof params.vacancyContractTypeTag == 'string'
              ? [params.vacancyContractTypeTag]
              : params.vacancyContractTypeTag,
          vacancyCountryTag:
            typeof params.vacancyCountryTag == 'string' ? [params.vacancyCountryTag] : params.vacancyCountryTag,
          vacancyStateProvinceTag:
            typeof params.vacancyStateProvinceTag == 'string'
              ? [params.vacancyStateProvinceTag]
              : params.vacancyStateProvinceTag,
          newsTypeTag: typeof params.newsTypeTag == 'string' ? [params.newsTypeTag] : params.newsTypeTag,
          teamMemberDisciplineTag:
            typeof params.teamMemberDisciplineTag == 'string'
              ? [params.teamMemberDisciplineTag]
              : params.teamMemberDisciplineTag,
          testimonialTag: typeof params.testimonialTag == 'string' ? [params.testimonialTag] : params.testimonialTag,
          vacancyLocationTag:
            typeof params.vacancyLocationTag == 'string' ? [params.vacancyLocationTag] : params.vacancyLocationTag,
          vacancyDepartmentTag:
            typeof params.vacancyDepartmentTag == 'string' ? [params.vacancyDepartmentTag] : params.vacancyDepartmentTag
        }

        const pageKind: PageKind = overviewPageParams.slug.toLowerCase()?.startsWith('resource-overview')
          ? 'resource-overview'
          : overviewPageParams.slug.toLocaleLowerCase()?.startsWith('vacancies')
          ? 'vacancy-overview'
          : overviewPageParams.slug.toLocaleLowerCase()?.startsWith('medewerkers')
          ? 'team-overview'
          : overviewPageParams.slug.toLocaleLowerCase()?.startsWith('actueel')
          ? 'news-overview'
          : overviewPageParams.slug.toLocaleLowerCase()?.startsWith('testimonials')
          ? 'testimonial-overview'
          : 'search-overview'

        return {
          ...state,
          route: {
            kind: 'overview',
            ...overviewPageParams,
            ...initialOverviewState(
              overviewPageParams,
              pageKind,
              state.route.kind == 'overview' ? state.route : undefined
            )
          }
        }
      }
  ),
  route<{ vacancyId: string; success?: string }, Updater<PublicSiteState>>(
    vacancyDetailPathPattern,
    ({ vacancyId, success }) =>
      (state): PublicSiteState => ({
        ...state,
        route:
          success == undefined
            ? { kind: 'vacancyDetail', success: false, ...initialVacancyDetailState(vacancyId) }
            : success == 'success'
            ? { kind: 'vacancyDetail', success: true, ...initialVacancyDetailState(vacancyId) }
            : { kind: '404' }
      })
  ),
  route<{ _?: string; queryParams?: string }, Updater<PublicSiteState>>(
    '/*',
    ({ _ }) =>
      (state): PublicSiteState => ({ ...state, route: { kind: 'drupalPage', slug: _, ...initialDrupalPageState(_) } })
  ),
  notFoundRouteCase<Updater<PublicSiteState>>(
    () =>
      (state): PublicSiteState => ({ ...state, route: { kind: '404' } })
  )
]

type OverviewParams = {
  lang: string
  slug: string
  page: string
  searchQuery?: string
  industryTag?: string[]
  typeTag?: string[]
  vacancyContractTypeTag?: string[]
  vacancyCountryTag?: string[]
  vacancyStateProvinceTag?: string[]
  vacancyLocationTag?: string[]
  vacancyDepartmentTag?: string[]
  newsTypeTag?: string[]
  teamMemberDisciplineTag?: string[]
  testimonialTag?: string[]
}
